import { EmptyStateBannerCombinedProps } from './types';

const usePresenter = (props: EmptyStateBannerCombinedProps): EmptyStateBannerCombinedProps => {
  return props;
};

export default usePresenter;
